<template>
  <section class="map" v-if="address">
    <div class="map__container">
      <h3
        v-if="!isFestivalYear"
        class="field__title"
        title="[另開新分頁]前往 Google Map"
      >
        <font-awesome-icon :icon="['fas', 'map-marker-alt']" />
        <a
          class="field__title__link"
          :href="`https://www.google.com.tw/maps/search/${address}`"
          target="_blank"
          :title="`[另開新分頁]前往${address}`"
          >{{ address }}</a
        >
      </h3>
      <h3
        v-else
        class="field__title field__title--festival-year"
        @click="openGoogleMapGuide"
        title="[另開新分頁]前往 Google Map"
      >
        <font-awesome-icon :icon="['fas', 'map-marker-alt']" />活動地點
      </h3>
      <a
        v-if="isFestivalYear"
        class="field__title__link"
        :href="`https://www.google.com.tw/maps/search/${address}`"
        target="_blank"
        :title="`[另開新分頁]前往${address}`"
        >{{ address }}</a
      >
      <div class="map__google-map" v-if="hasAnyPosition">
        <iframe
          width="100%"
          height="210"
          frameborder="0"
          style="border:0; border-radius: 5px;"
          :src="
            `https://www.google.com/maps/embed/v1/search?q=${address}&key=AIzaSyA8hVl2rmM70yal9Uh_6yW-K0KjeJpZWeI`
          "
          allowfullscreen
          :title="iframeTitle"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TempleGoogleMap',
  props: {
    iframeTitle: {
      type: String,
      default: '廟宇地圖',
      required: true,
    },
    address: {
      type: String,
      default: '',
      required: false,
    },
    position: {
      type: Object,
      default: () => ({
        lat: 0,
        lng: 0,
      }),
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isEmptyPropPosition() {
      const isEmpty = this.position.lat === 0 && this.position.lng === 0;
      return isEmpty;
    },
    hasAnyPosition() {
      return (
        !this.isEmptyPropPosition ||
        (this.isEmptyPropPosition && this.geoCodedPosition.lat)
      );
    },
    geoCodedPosition() {
      return this.$store.getters.geoCodedPosition;
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  async mounted() {
    if (this.isEmptyPropPosition) {
      await this.getGeoCodedPosition();
    }
  },
  methods: {
    getGeoCodedPosition() {
      if (!this.isEmptyPropPosition) {
        return;
      }

      if (this.address) {
        this.$emit('update:getGeoCodedPosition', {
          address: this.address,
        });
      }
    },
    openGoogleMapGuide() {
      if (Object.keys(this.position).length) {
        // 搜尋座標
        // window.open(
        //   `http://maps.google.com/maps?z=12&t=m&q=loc:${this.position.lat}+${this.position.lng}`
        // );

        // 搜尋地址
        window.open(`http://maps.google.com/maps?z=8&t=m&q=${this.address}`);
      }
    },
  },
  components: {
    // GmapCustomMarker,
  },
};
</script>

<style lang="scss" scoped>
.map {
  margin-bottom: 30px;
  max-width: 280px;
  margin-left: auto;
  margin-right: auto;

  @include for-tablet {
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  &__google-map {
    display: inline-block;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;

    @include for-tablet {
      margin-bottom: 0;
    }
  }
  .field__title__link {
    margin: 0;
    font-weight: 600;
    color: $color-light-text;
  }
}
</style>
